<template>
    <div>
        <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
        <div class="file-area clearfix">
            <swb-file-item v-for="(file, index) in contractFileList" :trackKey="index" :fileName="file.name" :fileUuid="file.fileUuid" :fileDownloadUrl="file.fileDownloaddUrl" :fileMd5="file.fileMd5" :editable="showDelete" :deletable="showDelete" :onDelete="deleteFile"></swb-file-item>
        </div>

    </div>
</template>

<script>
    import { Utils, H5file } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import SwbFileUpload from '../../compo/ctrl/FileUpload';
    Vue.regist(SwbFileUpload);

    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    export default {
        name: 'swb-save-file',
        desc: '保存合同文件',
        props: ['showDelete', 'files'],
        data: function () {
            return {
                percentage: 0,
                contractFileList: []
            }
        },
        created: function () {
            this.contractFileList = this.files;
        },
        methods: {
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                }
                let self = this;
                let contractFileList = self.contractFileList;
                for(var i = 0; i < fileItems.length; i++) {
                    for(var j = 0; j < contractFileList.length; j++) {
                        if(fileItems[i].name == contractFileList[i].name) {
                            MsgBox.warning('已存在相同的文件名称。');
                            return false;
                        }
                    }
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let contractFile = {};
                        contractFile.name = files[i].fileName;
                        contractFile.fileUuid = files[i].fileUuid;
                        contractFile.fileExtName = files[i].fileExtName;
                        contractFile.fileDownloaddUrl = files[i].fileDownloadUrl;
                        contractFile.fileMd5 = files[i].fileMd5;
                        self.contractFileList.push(contractFile);
                    }
                    /*self.contractFileList = Utils.merge([], contractFileList);*/
                } else {
                    MsgBox.success(result.message);
                }
            },
            deleteFile: function (fileInfo) {
                let self = this;
                let files = self.contractFileList;
                files.remove(files[fileInfo.trackKey]);
                self.contractFileList = Utils.merge([], files);
                return false;
            },
            downloadDemoFile: function (fileDownloaddUrl) {
                Utils.downloadFile(getAppUrl(fileDownloaddUrl));
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = 'info';
                result.data = self.contractFileList;
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/SaveFile.vue